import initialState from '../store/initialstate'
import C from  '../constants/mySettings';

export default (state = initialState().MySettings, action = null) => {
    let old = [];
    switch (action.type) {
        case C.GET_MY_SETTINGS_DATA:
            return state.set(C.MY_SETTINGS_DATA, action.payload);
        case C.GET_MY_LANGUAGE:
            return state.set(C.MY_LANGUAGE, action.payload);
        case C.GET_MY_TIMEZONE:
            return state.set(C.MY_TIMEZONE, action.payload);
        case C.GET_MY_DATE_INPUT_STYLE:
            return state.set(C.MY_DATE_INPUT_STYLE, action.payload);
        case C.GET_MY_FIRST_DAY_OF_WEEK:
            return state.set(C.MY_FIRST_DAY_OF_WEEK, action.payload);
        case C.GET_MY_DATE_FORMAT:
            return state.set(C.MY_DATE_FORMAT, action.payload);
        case C.GET_MY_SECURITY_QUESTIONS:
            return state.set(C.MY_SECURITY_QUESTIONS, action.payload);
        case C.GET_MY_CUSTOM_LIST_VALUES:
            old = state.getIn([C.MY_CUSTOM_LIST_VALUES]).values;
            old.push(action.payload);
            return state.set(C.MY_CUSTOM_LIST_VALUES, {
                values: old
            });
        case C.GET_MY_SSP_THEME:
            return state.set(C.MY_SSP_THEME, action.payload);
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./reducers/mySettings.js